export const aiAssistant = {
  save: "Mentés",
  mockWarning: {
    title: "🤖 Mock adatokkal dolgozik",
    description: "Ez a funkció valós AI generálást igényel, ami token költséggel jár. Jelenleg csak tesztelési célból mock (előre beállított) adatokat használunk."
  },
  chat: {
    title: "Beszélgessünk! 💬",
    subtitle: "Itt vagyok, hogy segítsek az álmaid weboldalával",
    welcomeMessage: "Szia! 👋 Szuper, hogy itt vagy! Segítek neked létrehozni a tökéletes weboldalt. Mesélj egy kicsit magadról és arról, mit szeretnél!",
    loadingMessages: [
      "Hmm, érdekes... 🤔",
      "Ó, ez jó ötlet! ✨", 
      "Már látom is, milyen lesz! 🎨",
      "Ezt imádni fogod! 😍",
      "Szuper választás! 🚀"
    ],
    placeholders: {
      default: "Írj bármit... én megértem! 😊",
      waiting: "Na, mesélj! Mit gondolsz? 🤗",
      multiselect: "Válassz bátran, vagy írj valami mást!",
      continue: "Szuper! Mit csinálunk tovább? ✨"
    }
  },
  quickActions: {
    paid: "Fizetős tartalom",
    interactive: "Interaktív funkció", 
    content: "Content",
    paidTitle: "Fizetős tartalom",
    interactiveTitle: "Interaktív funkciók",
    contentTitle: "Content felvitele",
    actions: {
      digitalProduct: "Új digitális termék feltöltés",
      privateMeeting: "Új privát meeting",
      groupMeeting: "Új csoportos meeting",
      questionForm: "Új kérdés form",
      personalVideo: "Új személyes videó rendelése", 
      package: "Új csomag",
      lottery: "Új sorsolás",
      quiz: "Új kvíz",
      poll: "Új szavazás", 
      subscription: "Új feliratkozás",
      promoCode: "Új promóciós kód",
      link: "Új link megadása",
      contentUpload: "Új content",
      embeddedVideo: "Új beágyazott videó",
      faq: "Új FAQ",
      reviews: "Új vélemények",
      howItWorks: "Új hogyan működik?"
    }
  },
  productIdeas: {
    title: "AI Termékötletelő",
    subtitle: "Generálj termékötleteket és építsd meg az AI Builderrel",
    selectType: "Terméktípus",
    generateButton: "Ötletek generálása",
    generating: "Generálás...",
    generatedIdeas: "Generált termékötletek",
    customize: "Testre szabás",
    customizeTitle: "Termékötlet testre szabása",
    customizeDescription: "Szabd testre az ötletet, majd küldd el az AI Weboldal Buildernek",
    sendToBuilder: "Küldés a Buildernek",
    productTitle: "Termék címe",
    productDescription: "Leírás",
    price: "Ár (Ft)",
    features: "Jellemzők (soronként egy)",
    targetAudience: "Célcsoport",
    cancel: "Mégse",
    ideaGenerated: "Termékötletek elkészültek!",
    ideaSentToBuilder: "Ötlet elküldve!",
    ideaSentDescription: "A termékötlet átadva az AI Weboldal Buildernek."
  }
};